export default (price: string | number, withDot = false): string => {
  return new Intl.NumberFormat("uk", {
    minimumFractionDigits: withDot ? 2 : 0,
    maximumFractionDigits: withDot ? 2 : 0
  }).format(+price)
}
